import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
import { ROUTES } from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { DashboardInformationService } from '../services/dashboard-information.service';
import { Store } from '@ngrx/store';
import * as PermissionActions from '../../permissions/store/permission.actions';
import * as DashboardInformationActions from '../../dashboardInformation/store/dashboard-information.actions';
import * as fromApp from '../../store/app.reducer';
import { Permission } from 'app/permissions/store/permission.model';
import { DashboardInformation } from 'app/dashboardInformation/store/dashboard-information.model';
import { BaseService } from "../services/base.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  // styleUrls:['./vertical-menu.component.css'],
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  public menuItemsDynamic: any[];
  level: number = 0;
  logoUrl = 'Content/9999/Other/OrgLogo.jpg';
  logoTitle = 'OccuCare';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  dashboardInformation: any;
  htmlString: any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private dashboardInformationService: DashboardInformationService,
    private store: Store<fromApp.AppState>,
    private baseService: BaseService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    this.menuItems = ROUTES;
    this.menuItemsDynamic = this.baseService.getLocalData('menuItemsDynamic');
    // this.baseService.callSecureAPI('POST', '/dashboardInformation/GetDashboardInformation')
    //   .subscribe((res) => {
    //     const res_item = this.baseService.getReposnse(res);
    //     if (res_item) {
    //       // const result = data;
    //       const dashboardInformation = JSON.parse(res_item);
    //       if (this.dashboardInformation.IsUserLoggedIn) {
    //         this.menuItemsDynamic = this.dashboardInformation.HorizontalUserMenuList ?
    //           JSON.parse(this.dashboardInformation.HorizontalUserMenuList) : '';
    //         const permissions: Permission[] = this.dashboardInformation.PermissionListData ?
    //           this.dashboardInformation.PermissionListData : [];
    //         this.store.dispatch(new PermissionActions.AddPermission(permissions));
    //         const dashboardInformation: DashboardInformation = new DashboardInformation(this.dashboardInformation.WelcomeText, this.dashboardInformation.DashboardUsername, this.dashboardInformation.UserProfileInformation);
    //         this.store.dispatch(new DashboardInformationActions.AddDashboardInformation(dashboardInformation));
    //       } else {
    //         debugger;
    //         var loginPageUrl = 'Pages/Baseframework/Security/Login';
    //         window.location.href = loginPageUrl;
    //       }
    //     }
    //   }, err => console.error(err));

    // this.dashboardInformationService.getDashboardInformation().subscribe(
    //   data => {
    //     const result = data;
    //     this.dashboardInformation = JSON.parse(result.data);
    //     if (this.dashboardInformation.IsUserLoggedIn) {
    //       this.menuItemsDynamic = this.dashboardInformation.HorizontalUserMenuList ?
    //         JSON.parse(this.dashboardInformation.HorizontalUserMenuList) : '';
    //       const permissions: Permission[] = this.dashboardInformation.PermissionListData ?
    //         this.dashboardInformation.PermissionListData : [];
    //       this.store.dispatch(new PermissionActions.AddPermission(permissions));
    //       const dashboardInformation: DashboardInformation = new DashboardInformation(this.dashboardInformation.WelcomeText, this.dashboardInformation.DashboardUsername, this.dashboardInformation.UserProfileInformation);
    //       this.store.dispatch(new DashboardInformationActions.AddDashboardInformation(dashboardInformation));
    //     } else {
    //       debugger;
    //       var loginPageUrl = 'Pages/Baseframework/Security/Login';
    //       window.location.href = loginPageUrl;
    //     }
    //   },
    //   err => console.error(err)
    // );
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      this.menuItems = ROUTES;
    }





    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

  navigateToRazorPath(pageUrl: any) {
    // // console.log("test submenu called");
    // window.location.href = '/Pages/Baseframework/MyDashBoard/';
    // window.location.href = '/Pages/MaterialManagement/InventoryPlanning/StoreLocationMaster';
    const redirectUrl = pageUrl.indexOf('/main/') >= 0 ? pageUrl.split('/main/')[1] : pageUrl;
    if (pageUrl.indexOf('/main/') >= 0) {
      this.router.navigate([`/${redirectUrl}`]);
    } else {
      window.location.href = pageUrl;
    }
    // if (pageUrl) {
    //   if (pageUrl.includes('stockstatus')) {
    //     this.router.navigateByUrl('/materialmanagement/stockstatus');
    //   } else if (pageUrl.includes('stockinward')) {
    //     this.router.navigateByUrl('/materialmanagement/stockinward');
    //   } else {
    //     window.location.href = pageUrl;
    //   }
    //   // switch(randomNumber) {
    //   //   case 1:
    //   //     this.router.navigateByUrl('/chat');
    //   //     break;
    //   //   case 2:
    //   //     this.router.navigateByUrl('/taskboard');
    //   //     break;
    //   //   case 3:
    //   //     this.router.navigateByUrl('/datatables');
    //   //     break;
    //   // }
    //   // var navigateToUrl = pageUrl.replace(window.location.origin, '');
    //   // window.location.href = navigateToUrl;
    // }
  }

}
